import { render } from "./TabularDatasetGraph.vue?vue&type=template&id=5a71c37d&scoped=true"
import script from "./TabularDatasetGraph.vue?vue&type=script&lang=js"
export * from "./TabularDatasetGraph.vue?vue&type=script&lang=js"

import "./TabularDatasetGraph.vue?vue&type=style&index=0&id=5a71c37d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a71c37d"]])

export default __exports__